// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

// webgen:import { "names": ["convertMetersToUnit"], "path": "@core/utils/unitHelpers" }
// webgen:import { "defaultName": "Enums", "path": "../Enums" }

import type { PartialDeep } from 'type-fest';

import { convertMetersToUnit } from '@core/utils/unitHelpers';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import Enums from '../Enums';

export class Distance {
  readonly meters: number;
  readonly text: string;

  constructor(data: { [key: string]: any } = {}) {
    this.meters = data.meters === undefined ? 0 : data.meters;
    this.text = data.text === undefined ? '' : data.text;
  }

  static zero(): Distance {
    const zeroValues: ExcludeMethodsDeep<Distance> = {
      meters: 0,
      text: '',
    };
    return new Distance(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  toUnit(unit: Enums.Unit): number {
    return Math.round(convertMetersToUnit(this.meters, unit));
  }

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type DistanceWireFormat = {
  meters: number;
  text: string;
};

type NewDistanceProps = PartialDeep<Distance, { recurseIntoArrays: true }>;
export const NewDistance: (props: NewDistanceProps) => Distance = (props) => new Distance(props);

type NewDistanceFromWireFormatProps = PartialDeep<DistanceWireFormat, { recurseIntoArrays: true }>;
export const NewDistanceFromWireFormat: (props: NewDistanceFromWireFormatProps) => Distance = (
  props,
) => new Distance(props);
